import * as _ from "lodash";
import CustomEvent from "custom-event";
import accountSwitchModalTemplate from "./../layout/view/header/accountSwitch/AccountSwitchModalTemplate";
import AccountDetailsFactory from "./AccountDetailsFactory";
import AccountListFactory from "./AccountListFactory";
import AuthenticationStatusService from "../authentication/AuthenticationStatusService";
import ExternalLogger from "../../ExternalLogger";
import FooterFactory from "../layout/service/factory/FooterFactory";
import PrimaryPlanFactory from "../plan/PrimaryPlanFactory";
import TransactionAccessRetrService from "../layout/service/TransactionAccessRetrService";
import AccountSwitchController from "../layout/view/header/accountSwitch/AccountSwitchController";
import DateUtil from "../util/DateUtil";

var accountService = function (
    $stateParams,
    $q,
    $rootScope,
    $modal,
    $window,
    AuthenticationStatusService,
    FooterFactory,
    TransactionAccessRetrService,
    accountDetailsFactory,
    accountListFactory,
    primaryPlanFactory
) {
    var logger = ExternalLogger.getInstance("AccountService");
    var computerShareWindow;
    var service = this;
    var accounts = [];
    var accountsGrouped = [];

    var summaryOfAllAccounts = {
        totalBalance: null,
        asOfDate: null
    };
    var activeGroupAccount = {
        individualId: null,
        groupId: null
    };
    var accountParams = ["individualId", "groupId"];
    var accountDetails = null;
    var primaryPlan = null;

    service.accountSummary = null;
    service.rateOfReturnObject = null;
    service.groupId = null;

    /**
     * Utility function to convert an object to an array.
     */
    function getObjAsArray(obj) {
        var result = [];
        if (obj) {
            result = _.isArray(obj) ? obj : [obj];
        }
        return result;
    }

    /**
     * Return the active group account.
     */
    service.getActiveGroupAccount = function () {
        return activeGroupAccount;
    };

    service.getCurrentAccount = function () {
        if (service.currentAccount) {
            return service.currentAccount;
        } else {
            const allAccounts = service.getAccounts();
            const currentAccount = allAccounts.find(function (account) {
                return (
                    activeGroupAccount.groupId === account.groupId &&
                    activeGroupAccount.individualId === account.individualId
                );
            });
            return currentAccount;
        }
    };

    /**
     * Return the default account.
     * TODO: Implement this with real logic, as would be used by the
     * best next step module and advice page.
     */
    service.getPrimaryGroupAccount = function () {
        if (primaryPlan) {
            return primaryPlan;
        } else {
            return service.setPrimaryGroupAccount().then(function () {
                return primaryPlan;
            });
        }
    };

    service.setPrimaryGroupAccount = function () {
        var deferred = $q.defer();

        primaryPlanFactory.query(
            {},
            function (plan) {
                if (plan.indId && plan.gaId) {
                    primaryPlan = {
                        individualId: plan.indId,
                        groupId: plan.gaId
                    };
                    return deferred.resolve();
                } else {
                    return deferred.reject("Invalid primary plan");
                }
            },
            function (err) {
                logger.error("ERROR - primaryPlanFactory: ", err);
                return deferred.reject(err);
            }
        );
        return deferred.promise;
    };

    /**
     * Return accounts as an object (for the account list page).
     */
    service.getAccountsGrouped = function () {
        return accountsGrouped;
    };

    /**
     * Return accounts as an array.
     */
    service.getAccounts = function () {
        //console.log("getAccounts-->",accounts.length, accounts);
        return accounts;
    };

    /**
     * Return summary info for all accounts
     */
    service.getSummaryOfAllAccounts = function () {
        return summaryOfAllAccounts;
    };

    /**
     * Sets the lists of accounts (grouped and flat), and returns a promise.
     */
    service.setAccounts = function () {
        var deferred = $q.defer();
        if (accounts.length) {
            deferred.resolve(accounts);
        } else {
            AuthenticationStatusService.getAuthData().then(function (data) {
                function propertyToBoolean(val) {
                    var booleanState = ["false", "true"].indexOf(val);
                    return booleanState >= 0 ? Boolean(booleanState) : val;
                }
                var authStatus = _.mapValues(data, propertyToBoolean);

                if (authStatus.authenticated) {
                    accountListFactory.accountSummary.query(
                        function (data) {
                            accountsGrouped = data;
                            // _.extend wasn't working..changed to push instead

                            // set summary data
                            summaryOfAllAccounts.asOfDate = data.asOfDate;
                            summaryOfAllAccounts.totalBalance = data.totalBalance;

                            var tmpAccounts = [];
                            getObjAsArray(data.nonMonthlyAccounts).forEach(function (account) {
                                tmpAccounts.push(account);
                            });
                            getObjAsArray(data.monthlyAccounts).forEach(function (account) {
                                tmpAccounts.push(account);
                            });
                            // commented out support for credit accounts until these are supported...
                            //getObjAsArray(data.creditAccounts).forEach(function(account) {
                            //     tmpAccounts.push(account);
                            //});
                            accounts = service.sortPlans(tmpAccounts);

                            deferred.resolve(accounts);
                        },
                        function (error) {
                            console.error("error settings accounts", error);
                            deferred.reject(error);
                        }
                    );
                } else {
                    // not yet authenticated
                    deferred.reject("User is not authenticated.");
                }
            });
        }
        return deferred.promise;
    };

    /**
     * Sets the active group account from the account hash in the URL or from an argument.
     */
    service.setActiveGroupAccount = function (account) {
        var deferred = $q.defer();
        var method = "setActiveGroupAccount()";
        var indId = null;
        var gaId = null;

        logger.debug("In method: {0} ", [method]);

        if ($stateParams.individualId || $stateParams.indId) {
            indId = !$stateParams.individualId ? $stateParams.indId : $stateParams.individualId;
            $stateParams.individualId = indId;
            $stateParams.indId = indId;
        }
        if ($stateParams.gaId || $stateParams.groupId) {
            gaId = !$stateParams.groupId ? $stateParams.gaId : $stateParams.groupId;
            $stateParams.groupId = gaId;
            $stateParams.gaId = gaId;
        }

        if (account) {
            logger.debug("{0}- ActiveGroupAcct is set to specific account. idId={1}, gaId={2}", [
                method,
                account.individualId,
                account.groupId
            ]);
            activeGroupAccount = account;
            //service.setAccountHash(account);
            deferred.resolve(activeGroupAccount);
        } else if (!indId || !gaId) {
            //Default account if there is no account hash URL param
            logger.debug("{0}- No state params, so using PrimaryPlan as active group account.", [
                method
            ]);
            service.setAccounts().then(
                function () {
                    logger.debug(
                        "{0}-    setAccounts got called. Now call setPrimaryGroupAccount() ",
                        [method]
                    );
                    service.setPrimaryGroupAccount().then(function () {
                        logger.debug("{0}-     activeGroupAccount={1}, primaryGroupAccount={2}", [
                            method,
                            activeGroupAccount.groupId,
                            service.getPrimaryGroupAccount().groupId
                        ]);
                        accountParams.forEach(function (param) {
                            activeGroupAccount[param] = service.getPrimaryGroupAccount()[param];
                        });
                        logger.debug(
                            "{0}-    Active account is now PrimaryGroupAccount: indId={1}, gaId={2}",
                            [method, activeGroupAccount.individualId, activeGroupAccount.groupId]
                        );
                        deferred.resolve(activeGroupAccount);
                    });
                },
                function (rejection) {
                    logger.debug("{0}- Error setting active group account", [method]);
                    deferred.reject(rejection);
                }
            );
        } else {
            // accountHash = $stateParams.accountHash;
            // var params = base32.decode(accountHash).split(',');
            logger.debug("{0}-  Setting activeAccount with $state params.", [method]);
            if ($stateParams.indId) {
                $stateParams.individualId = $stateParams.indId;
            }
            accountParams.forEach(function (param) {
                activeGroupAccount[param] = $stateParams[param];
            });
            logger.debug("{0}-  with $state params, active account is: indId={1}, gaId={2}", [
                method,
                activeGroupAccount.individualId,
                activeGroupAccount.groupId
            ]);
            deferred.resolve(activeGroupAccount);
        }
        return deferred.promise;
    };

    /**
     * Returns whether the given account is currently selected in the menu.
     */
    service.isAccountSelected = function (account) {
        var selected = true;
        accountParams.forEach(function (param) {
            if (activeGroupAccount[param] !== account[param]) {
                selected = false;
            }
        });
        return selected;
    };

    /**
     * Returns selected account (with info such as its name, not the group object)
     */
    service.getSelectedAccount = function () {
        var deferred = $q.defer();
        var selectedAccount;

        service.setAccounts().then(function (accountsList) {
            deferred.resolve(_.find(accountsList, service.isAccountSelected));
        });

        return deferred.promise;
    };

    /**
     * Returns primary plan based on indId
     * 10/16/2019
     */
    service.primaryPlanByIndId = function (accountRequest) {
        var deferred = $q.defer();

        accountDetailsFactory.primaryPlanByIndId.query(
            accountRequest,
            function (data) {
                deferred.resolve(data);
            },
            function (err) {
                logger.error(
                    "ERROR - accountDetailsFactory.primaryPlanByIndId: Account Details Error: " +
                        err
                );
                return deferred.reject(err);
            }
        );
        return deferred.promise;
    };

    /**
     * updates default plan based on indId, accucode
     * 10/16/2019
     */
    service.updateDefaultPlan = function (req) {
        var deferred = $q.defer();
        accountDetailsFactory.updateDefaultPlan.query(
            req,
            function (response) {
                deferred.resolve(response.data);
            },
            function (err) {
                logger.error(
                    "ERROR - accountDetailsFactory.updateDefaultPlan: Account Details Error: " + err
                );
                return deferred.reject(err);
            }
        );
        return deferred.promise;
    };

    service.updateEngDefaultPlan = function (req) {
        var deferred = $q.defer();
        accountDetailsFactory.updateEngDefaultPlan.query(
            req,
            function (response) {
                logger.debug("updateEngDefaultPlan data in accountService ::" + response.data);
                deferred.resolve(response.data);
            },
            function (err) {
                logger.error(
                    "ERROR - accountDetailsFactory.updateEngDefaultPlan: Account Details Error: " +
                        err
                );
                return deferred.reject(err);
            }
        );
        return deferred.promise;
    };

    /**
     * Allow the switch plan context modal to be accesible outside of the nav
     * 10/30/2019
     * Based on selected asset, display associated "primary plan" that it will switch to
     */
    service.switchPlan = function (asset, isList) {
        let planId = asset.groupId;
        let indId = asset.individualId; //PART-45063 EGS
        window.dispatchEvent(new CustomEvent("switch-plan", { detail: { planId, indId } })); //PART-45063 EGS
    };

    service.concatenatedPlans = function (allAccounts) {
        // Below code is for displaying plan names under left nav dropdown to support OneId feature
        // PLAN-9260
        var contextData = {};

        var nonCurrentContextNums = {};
        var nonCurrentcontenxtPlanName = {};

        angular.forEach(allAccounts, function (item) {
            var contextKey = item.individualId + "-" + item.accuCode;
            if (
                item.currentContext &&
                allAccounts.length > 1 &&
                service.getActiveGroupAccount().individualId &&
                item.individualId &&
                service.getActiveGroupAccount().individualId != item.individualId
            ) {
                item.currentContext = false;
            }
            if (item.currentContext) {
                var displayPlanName = item.name;
                if (displayPlanName && displayPlanName.length > 80) {
                    item.contextPlanName = displayPlanName.slice(0, 80) + "\u2026";
                }
                contextData[contextKey] = item.contextPlanName;
            } else {
                //concatenating plannames for other context plans
                if (contextData[contextKey]) {
                    if (nonCurrentContextNums[contextKey] < 3) {
                        var concatenatedPlanName =
                            contextData[contextKey] +
                            ", " +
                            (checkCharCount(item.name, 26)
                                ? item.name.slice(0, 26) + "\u2026"
                                : item.name);
                        contextData[contextKey] = concatenatedPlanName;
                        nonCurrentContextNums[contextKey]++;
                    }
                } else {
                    contextData[contextKey] = checkCharCount(item.name, 26)
                        ? item.name.slice(0, 26) + "\u2026"
                        : item.name;
                    nonCurrentContextNums[contextKey] = 1;
                    nonCurrentcontenxtPlanName[contextKey] = item.name;
                }
            }
        });

        angular.forEach(allAccounts, function (item) {
            if (item.currentContext) {
                item.contextPlanName =
                    item.name.length > 80 ? item.name.slice(0, 80) + "\u2026" : item.name;
            } else {
                var contextKey = item.individualId + "-" + item.accuCode;
                if (nonCurrentContextNums[contextKey] && nonCurrentContextNums[contextKey] == 1) {
                    contextData[contextKey] = checkCharCount(
                        nonCurrentcontenxtPlanName[contextKey],
                        80
                    )
                        ? nonCurrentcontenxtPlanName[contextKey].slice(0, 80) + "\u2026"
                        : nonCurrentcontenxtPlanName[contextKey];
                }
                var planName = contextData[contextKey];
                item.contextPlanName = planName;
                delete contextData[contextKey];
            }
        });
        return allAccounts;
    };

    function checkCharCount(str, len) {
        if (str != null && str != "" && str != "undefined" && str.length > len) {
            return true;
        }
        return false;
    }

    service.sortPlans = function (allAccounts) {
        var currentContextPlans = [];
        var otherContextPlans = [];
        var nmrowList = {};
        var prevNMPlan = {};
        var combinedPlanList = [];
        if (allAccounts.length > 1) {
            // sort plans by gaId for current context
            var inContextListInit = _.filter(allAccounts, (item) => {
                return item.currentContext;
            });
            currentContextPlans = _.sortBy(inContextListInit, (o) => o.groupId);

            // sort by indId and gaId for out of context plans
            var outOfContextListInit = _.filter(allAccounts, (item) => {
                return !item.currentContext;
            });
            var outOfContextList = _.sortBy(outOfContextListInit, (o) => o.individualId);

            _.forEach(outOfContextList, function (nmplan) {
                let key = nmplan.individualId + "-" + nmplan.accuCode;

                if (nmrowList[key] === undefined || nmrowList[key] === null) {
                    nmplan.showToolTip = String(nmplan.name).length > 18 ? true : false;
                    //  nmplan.isEmulator = vm.isEmulator;
                    nmrowList[key] = [];
                    nmrowList[key].push(nmplan);
                    prevNMPlan = nmplan;
                } else {
                    nmplan.showToolTip = String(nmplan.name).length > 18 ? true : false;
                    //  nmplan.isEmulator = vm.isEmulator;
                    nmrowList[key].push(nmplan);
                    prevNMPlan = nmplan;
                }
            });

            Object.keys(nmrowList).forEach(function (key, index) {
                if (nmrowList[key].length > 1) {
                    var sortedOtherContextPlans = _.sortBy(nmrowList[key], (o) => o.groupId);
                    _.forEach(sortedOtherContextPlans, function (plan) {
                        otherContextPlans.push(plan);
                    });
                } else if (nmrowList[key].length == 1) {
                    otherContextPlans.push(nmrowList[key][0]);
                }
            }, nmrowList);

            //  scope.allAccounts = _.concat(currentContextPlans,otherContextPlans);

            _.forEach(currentContextPlans, function (plan) {
                combinedPlanList.push(plan);
            });
            _.forEach(otherContextPlans, function (plan) {
                combinedPlanList.push(plan);
            });
        } else {
            combinedPlanList = allAccounts;
        }
        return combinedPlanList;
    };

    /**
     * If current location is in LIAT (dashboard/), bypass broadcast to update
     */
    function openModal() {
        var currentLocationHref = $window.location.href;

        var modalInstance = $modal.open({
            template: accountSwitchModalTemplate,
            controller: AccountSwitchController,
            controllerAs: "switchPlanCtrl",
            size: "md",
            windowClass: "auto-increase-wrapper"
        });
        modalInstance.result.then(
            function (acct) {
                service.currentAccount = acct;
            },
            function (acct) {
                if (!(currentLocationHref.indexOf("dashboard/") > -1)) {
                    $rootScope.$broadcast("currentAccountUpdated", acct.planName);
                    service.currentAccount = acct;
                }
            }
        );
    }

    /**
     * Uses activeGroupAccount parameters to run a query for account details. Can run a callback function.
     */
    service.setAccountDetails = function (account) {
        var method = "setAccountDetails()";
        logger.debug("In {0} method. ", [method]);
        var deferred = $q.defer();
        if (account) {
            logger.debug(
                "{0}- account input param is passed in. Calling accountDetailsFactory with gaId={1} indId={2} db={3}",
                [method, account.groupId, account.individualId, account.dbName]
            );
            accountDetailsFactory.accountDetails.query(account, function (data) {
                accountDetails = data;
                logger.debug("{0}-    Got accountDetails. groupId={1}, accountUrl={2}", [
                    method,
                    accountDetails.groupId,
                    accountDetails.accountURL
                ]);
                deferred.resolve(accountDetails);
            });
        } else {
            if (service.getActiveGroupAccount().groupId === null) {
                logger.debug(
                    "{0}- Local variable activeGroupAccount is not set. Calling setActiveGroupAccount() first.",
                    [method]
                );
                service.setActiveGroupAccount().then(function () {
                    logger.debug(
                        "{0}-   After setActiveGroupAccount(), now calling accountDetailsFactory for gaId= {1}",
                        [method, activeGroupAccount.groupId]
                    );
                    accountDetailsFactory.accountDetails.query(activeGroupAccount, function (data) {
                        accountDetails = data;
                        logger.debug("{0}-    Got accountDetails. groupId={1}, accountUrl={2}", [
                            method,
                            accountDetails.groupId,
                            accountDetails.accountURL
                        ]);
                        deferred.resolve(accountDetails);
                    });
                });
            } else {
                logger.debug(
                    "{0}- Local activeGroupAccount is already set. Calling accountDetailsFactory for local activeGroupAccount.groupId= {1}",
                    [method, activeGroupAccount.groupId]
                );
                accountDetailsFactory.accountDetails.query(activeGroupAccount, function (data) {
                    accountDetails = data;
                    logger.debug("{0}-    Got accountDetails. groupId={1}, accountUrl={2}", [
                        method,
                        accountDetails.groupId,
                        accountDetails.accountURL
                    ]);
                    deferred.resolve(accountDetails);
                });
            }
        }

        return deferred.promise;
    };

    /**
     * Simple getter to return the accountDetails object
     *
     * @returns {*}
     */
    service.getAccountDetails = function () {
        return accountDetails;
    };

    service.getBankAccountsList = function (params) {
        var deferred = $q.defer();

        accountDetailsFactory.getBankAccounts(params).then(
            function success(bankAccounts) {
                deferred.resolve(bankAccounts);
            },
            function error(fault) {
                deferred.reject(fault);
            }
        );

        return deferred.promise;
    };

    service.getChatAccountDetails = function (chatData) {
        var deferred = $q.defer();
        var accountRequest = {
            individualId: chatData.participantIdNumber,
            groupId: chatData.planNumber
        };

        accountDetailsFactory.accountDetails.query(
            accountRequest,
            function (acctDetails) {
                chatData.participantName = acctDetails.firstName + " " + acctDetails.lastName;
                chatData.planName = acctDetails.description;

                if ($rootScope.sendLivePersonVariables) {
                    $rootScope.sendLivePersonVariables(chatData);
                }

                deferred.resolve(chatData);
            },
            function (err) {
                //console.error("Account Details Error: " + err);
                return deferred.reject(err);
            }
        );
        return deferred.promise;
    };

    service.getAccountSummary = function () {
        var method = "getAccountSummary()";
        var deferred = $q.defer();
        logger.debug("In {0} method", [method]);

        logger.debug("{0}- ActiveGroupAccount = {1}", [method, activeGroupAccount.groupId]);
        logger.debug("{0}- Calling setActiveGroupAccount()", [method]);
        service.setActiveGroupAccount().then(function () {
            logger.debug("{0}-  got activeGroupAccount. ", [method]);
            if (
                service.groupId &&
                activeGroupAccount.groupId === service.groupId &&
                service.accountSummary
            ) {
                logger.debug(
                    "{0}-   Current group ({1}) is activeGroupAccount. Resolve to current accountSummary. ",
                    [method, service.groupId]
                );
                deferred.resolve(service.accountSummary);
            }
            logger.debug(
                "{0}-  About to call accountDetailsFactory for activeGroupAccount gaId={1}",
                [method, activeGroupAccount.groupId]
            );
            accountDetailsFactory.getSummary.query(
                {
                    individualId: activeGroupAccount.individualId,
                    groupId: activeGroupAccount.groupId
                },
                function (response) {
                    if (
                        !response ||
                        !response.data ||
                        response.error ||
                        response.status !== "SUCCESSFUL"
                    ) {
                        logger.debug("{0}-   Account details summary returned error. ", [method]);
                        deferred.reject("account details summary response error");
                    }
                    service.accountSummary = response.data;

                    logger.debug("{0}-  Got summary of activeGroupId. Resolve.", [method]);
                    //console.log("AccountSummary",service.accountSummary);
                    deferred.resolve(service.accountSummary);
                },
                deferred.reject
            );
        });
        return deferred.promise;
    };

    service.getRateOfReturn = function (params) {
        var deferred = $q.defer();
        service.setActiveGroupAccount().then(function () {
            if (
                service.groupId &&
                activeGroupAccount.groupId === service.groupId &&
                service.rateOfReturnObject
            ) {
                deferred.resolve(service.rateOfReturnObject);
            }
            var txnCodeParams = {
                txnCode: "WNROR",
                individualId: activeGroupAccount.individualId,
                groupId: activeGroupAccount.groupId
            };

            TransactionAccessRetrService.queryWithAccount(
                txnCodeParams,
                function (response) {
                    if (!response || response.WNROR !== "true") {
                        logger.debug(
                            "AccountService.getRateOfReturn() - WNROR is not enabled for plan {0}",
                            [activeGroupAccount.groupId]
                        );
                        deferred.reject("notEnabled");
                    }

                    var startDate, endDate;
                    if (params) {
                        startDate = params.startDate;
                        endDate = params.endDate;
                    } else {
                        startDate = DateUtil.getDateFormatted(
                            "DD-MMM-YYYY",
                            DateUtil.subtractFromDate(3, "year")
                        );
                        endDate = DateUtil.getDateFormatted("DD-MMM-YYYY");
                    }
                    logger.debug(
                        "AccountService.getRateOfReturn() - call accountDetailsFactory.getRateOfReturm.query() with startDate={0}, enddate={1}",
                        [startDate, endDate]
                    );
                    accountDetailsFactory.getRateOfReturn.query(
                        {
                            groupId: activeGroupAccount.groupId,
                            startDate: startDate,
                            endDate: endDate
                        },
                        function (response) {
                            if (
                                !response ||
                                !response.data ||
                                response.error ||
                                response.status !== "SUCCESSFUL"
                            ) {
                                deferred.reject();
                            }
                            service.rateOfReturnObject = response.data;
                            deferred.resolve(service.rateOfReturnObject);
                        },
                        deferred.reject
                    );
                },
                function (error) {
                    logger.debug(
                        "AccountService.getRateOfReturn() - TransactionAccessRetrService.queryWithAccount() failed for WNROR, gaId={0} ",
                        [activeGroupAccount.groupId]
                    );
                    deferred.reject();
                }
            );
        });
        return deferred.promise;
    };

    service.getBalanceKTMGEnabled = function (params) {
        var deferred = $q.defer();
        service.setActiveGroupAccount().then(function () {
            if (
                service.groupId &&
                activeGroupAccount.groupId === service.groupId &&
                service.rateOfReturnObject
            ) {
                deferred.resolve(service.rateOfReturnObject);
            }
            var txnCodeParams = {
                txnCode: "WNBALA,WNBALH",
                individualId: activeGroupAccount.individualId,
                groupId: activeGroupAccount.groupId
            };

            var balEnabled = {
                WNBALA: null,
                WNBALH: null
            };

            TransactionAccessRetrService.queryWithAccount(
                txnCodeParams,
                function (response) {
                    if (response != null) {
                        balEnabled.WNBALA = response.WNBALA;
                        balEnabled.WNBALH = response.WNBALH;
                        logger.debug(
                            "AccountService.getBalanceEnabledData() - for plan {0} -WNBALA {1} - WNBALH {2}",
                            [activeGroupAccount.groupId],
                            response.WNBALA,
                            response.WNBALH
                        );
                        deferred.resolve(balEnabled);
                    } else {
                        logger.debug(
                            "AccountService.getBalanceEnabledData() has failed for gaId={0} ",
                            [activeGroupAccount.groupId]
                        );
                        deferred.reject();
                    }
                },
                function (error) {
                    logger.debug(
                        "AccountService.getBalanceEnabledData() has failed for gaId={0} ",
                        [activeGroupAccount.groupId]
                    );
                    deferred.reject();
                }
            );
        });
        return deferred.promise;
    };

    function getComputerShareSamlToken(account) {
        var deferred = $q.defer();
        var getComputerShareSamlTokenParams = {};
        var tokenFunction = accountDetailsFactory.getComputerShareSamlToken;

        if (account && account.individualId) {
            getComputerShareSamlTokenParams = {
                individualId: account.individualId,
                groupId: account.groupId
            };
            // tokenFunction = adviceFactory.getFeSamlTokenForPlan;
        }

        tokenFunction.query(
            getComputerShareSamlTokenParams,
            function (data) {
                deferred.resolve(data);
            },
            function (response) {
                $state.go("error");
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    var getComputerShareSamlTokenResult = function (data) {
        var deferred = $q.defer();
        logger.info("getComputerShareSamlTokenResult()");
        document.querySelector("#SAMLResponse").innerHtml = filterSamlData(data.samlResponse);
        document.getElementById("#SAMLFORM").setAttribute("action", data.postUrl);
        computerShareWindow = window.open("", "computerShareWindow");
        document.getElementById("#SAMLFORM").setAttribute("target", "computerShareWindow");

        if (computerShareWindow) {
            return $q.when();
        }

        return deferred.promise;
    };

    service.navigateComputerShare = function () {
        var deferred = $q.defer();
        logger.info("navigateComputerShare()");

        var getComputerShareSamlTokenFault = function () {
            logger.info("getComputerShareSamlTokenFault()");

            var errorMessage = "There was an error launching managed accounts.";

            if (
                !computerShareWindow ||
                computerShareWindow.closed ||
                typeof computerShareWindow.closed == "undefined"
            ) {
                errorMessage +=
                    " Please disable your pop up blocker to view your managed accounts.";
            }
            alert(errorMessage);
            deferred.reject();
        };

        getComputerShareSamlToken(accountService.getActiveGroupAccount())
            .then(getComputerShareSamlTokenResult)
            .then(deferred.resolve)
            .catch(getComputerShareSamlTokenFault);

        return deferred.promise;
    };

    service.setProviderUrlAndPhoneNumberObject = function () {
        var deferred = $q.defer();
        service.setActiveGroupAccount().then(function () {
            accountDetailsFactory.getProviderUrlAndPhoneNumber.query(
                {
                    individualId: activeGroupAccount.individualId,
                    groupId: activeGroupAccount.groupId
                },
                function (data) {
                    service.urlPhoneNumberData = data.data;
                    deferred.resolve();
                },
                function (error) {
                    console.error("error getting phone number and provider url data", error);
                    deferred.reject();
                }
            );
        });

        return deferred.promise;
    };

    service.setSiteContactInfoForPlan = function (account) {
        FooterFactory.query(
            {
                gaId: account.groupId
            },
            function (data) {
                if ($rootScope.siteContactInfo) {
                    $rootScope.siteContactInfo.phone = data.phone;
                    $rootScope.siteContactInfo.beginTime = data.beginTime;
                    $rootScope.siteContactInfo.endTime = data.endTime;
                    $rootScope.siteContactInfo.timeZone = data.timeZone;
                    $rootScope.siteContactInfo.endTime = data.endTime;
                    $rootScope.siteContactInfo.tdd = data.tdd;
                    $rootScope.siteContactInfo.intlNumber = data.intlNumber;
                    $rootScope.siteContactInfo.alias = data.alias;
                    $rootScope.siteContactInfo.email = data.email;
                }

                if ($rootScope.phoneNumber) {
                    $rootScope.phonenumber.planSpecificNum = data.phone;
                    if ($rootScope.phonenumber.planSpecificNum !== null) {
                        $rootScope.isNotClickable = "true";
                    }
                }
            }
        );
    };

    service.isGroupAccountServiceExist = function (params) {
        var method = "isGroupAccountServiceExist()";
        logger.debug("In method: {0} ", [method]);
        logger.debug(
            "{0}- check if the GA service exist for gaId={1} , sdsvcode={2} . sdsvSubCode = {3}",
            [method, activeGroupAccount.groupId, params.sdsvCode, params.sdsvSubcode]
        );

        var deferred = $q.defer();
        accountDetailsFactory.isGroupAccountServiceExist.query(
            {
                individualId: activeGroupAccount.individualId,
                groupId: activeGroupAccount.groupId,
                sdsvCode: params.sdsvCode,
                sdsvSubcode: params.sdsvSubcode
            },
            function (response) {
                service.gaServiceExist = response.data;
                deferred.resolve();
            },
            function (data) {
                deferred.reject();
            }
        );
        return deferred.promise;
    };
};

accountService.$inject = [
    "$stateParams",
    "$q",
    "$rootScope",
    "$modal",
    "$window",
    "AuthenticationStatusService",
    "FooterFactory",
    "TransactionAccessRetrService",
    "accountDetailsFactory",
    "accountListFactory",
    "primaryPlanFactory"
];

export default accountService;
